import { createWebHistory, createRouter } from "vue-router";
import Podcast from "@/views/Podcast.vue";

const routes = [
  {
    path: "/:ct",
    name: "Podcast",
    component: Podcast,
  },
  {
    path: "/player-podcast/:ct",
    name: "EmpPodcast",
    component: Podcast,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;